export function TransactionTypeEmpty({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="200"
        height="152"
        viewBox="0 0 200 152"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_83_16087)">
          <path
            d="M81 38H57C50.3726 38 45 43.3726 45 50V74C45 80.6274 50.3726 86 57 86H81C87.6274 86 93 80.6274 93 74V50C93 43.3726 87.6274 38 81 38Z"
            fill="var(--clr-container-bg)"
            stroke="var(--clr-border-grey-100)"
          />
          <path
            d="M145 38H121C114.373 38 109 43.3726 109 50V74C109 80.6274 114.373 86 121 86H145C151.627 86 157 80.6274 157 74V50C157 43.3726 151.627 38 145 38Z"
            fill="var(--clr-container-bg)"
            stroke="var(--clr-border-grey-100)"
          />
          <path
            d="M81 100H57C50.3726 100 45 105.373 45 112V136C45 142.627 50.3726 148 57 148H81C87.6274 148 93 142.627 93 136V112C93 105.373 87.6274 100 81 100Z"
            fill="var(--clr-container-bg)"
            stroke="var(--clr-border-grey-100)"
          />
          <path
            d="M145 100H121C114.373 100 109 105.373 109 112V136C109 142.627 114.373 148 121 148H145C151.627 148 157 142.627 157 136V112C157 105.373 151.627 100 145 100Z"
            fill="var(--clr-container-bg)"
            stroke="var(--clr-border-grey-100)"
          />
          <path
            opacity="0.85"
            d="M70.5 58H67.5C66.1193 58 65 59.1193 65 60.5V63.5C65 64.8807 66.1193 66 67.5 66H70.5C71.8807 66 73 64.8807 73 63.5V60.5C73 59.1193 71.8807 58 70.5 58Z"
            fill="var(--clr-general-primary)"
          />
          <path
            opacity="0.4"
            d="M134.5 58H131.5C130.119 58 129 59.1193 129 60.5V63.5C129 64.8807 130.119 66 131.5 66H134.5C135.881 66 137 64.8807 137 63.5V60.5C137 59.1193 135.881 58 134.5 58Z"
            fill="var(--clr-general-primary)"
          />
          <path
            opacity="0.4"
            d="M70.5 120H67.5C66.1193 120 65 121.119 65 122.5V125.5C65 126.881 66.1193 128 67.5 128H70.5C71.8807 128 73 126.881 73 125.5V122.5C73 121.119 71.8807 120 70.5 120Z"
            fill="var(--clr-general-primary)"
          />
          <path
            opacity="0.85"
            d="M134.5 120H131.5C130.119 120 129 121.119 129 122.5V125.5C129 126.881 130.119 128 131.5 128H134.5C135.881 128 137 126.881 137 125.5V122.5C137 121.119 135.881 120 134.5 120Z"
            fill="var(--clr-general-primary)"
          />
          <path
            d="M84 90C88 94.6667 92 94.6667 96 90"
            stroke="var(--clr-general-description)"
            strokeLinecap="round"
          />
          <path
            d="M104 90C108 94.6667 112 94.6667 116 90"
            stroke="var(--clr-general-description)"
            strokeLinecap="round"
          />
          <path
            d="M92 104C97.3333 108 102.667 108 108 104"
            stroke="var(--clr-general-description)"
            strokeLinecap="round"
          />
          <path
            opacity="0.18"
            d="M78.5 102.5C80.1569 102.5 81.5 101.157 81.5 99.5C81.5 97.8431 80.1569 96.5 78.5 96.5C76.8431 96.5 75.5 97.8431 75.5 99.5C75.5 101.157 76.8431 102.5 78.5 102.5Z"
            fill="var(--clr-general-primary)"
          />
          <path
            opacity="0.18"
            d="M118.5 102.5C120.157 102.5 121.5 101.157 121.5 99.5C121.5 97.8431 120.157 96.5 118.5 96.5C116.843 96.5 115.5 97.8431 115.5 99.5C115.5 101.157 116.843 102.5 118.5 102.5Z"
            fill="var(--clr-general-primary)"
          />
          <path
            d="M70 21C70 29.6667 73.3333 37 80 43"
            stroke="var(--clr-title)"
            strokeOpacity="0.2"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeDasharray="1 7"
          />
          <path
            opacity="0.9"
            d="M68.0008 15C66.5397 7.9385 70.6417 3.12461 76.5794 4.44507C76.1861 10.7574 72.4587 14.6441 68.0008 15Z"
            fill="var(--clr-general-primary)"
          />
          <path
            opacity="0.65"
            d="M68.0004 15.0001C61.688 14.6068 58.5506 9.02507 60.7982 3.46197C66.3613 5.70961 68.9462 9.98959 68.0004 15.0001Z"
            fill="var(--clr-general-primary)"
          />
          <path
            opacity="0.45"
            d="M31 90L33 95L38 97L33 99L31 104L29 99L24 97L29 95L31 90Z"
            fill="var(--clr-general-primary)"
          />
          <path
            opacity="0.4"
            d="M170 21.5999C171.436 21.5999 172.6 20.4358 172.6 18.9999C172.6 17.564 171.436 16.3999 170 16.3999C168.564 16.3999 167.4 17.564 167.4 18.9999C167.4 20.4358 168.564 21.5999 170 21.5999Z"
            fill="var(--clr-general-primary)"
          />
        </g>
        <defs>
          <clipPath id="clip0_83_16087">
            <rect width="200" height="152" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
}
